import { render, staticRenderFns } from "./jobstype.vue?vue&type=template&id=53ef2f21&"
import script from "./jobstype.vue?vue&type=script&lang=js&"
export * from "./jobstype.vue?vue&type=script&lang=js&"
import style0 from "./jobstype.vue?vue&type=style&index=0&id=53ef2f21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports